import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardExercisesCategoryEdit = guard(groupRights.ExerciseCategory)('edit')
export const guardExercisesCategoryWatch = guard(groupRights.ExerciseCategory)('watch')
export const guardExercisesCategoryCreate = guard(groupRights.ExerciseCategory)('create')

